import ViewType from "../dataview/ViewType";
import DataView from "../dataview/DataView";
import FieldType from "../datamodule/FieldType";
import ViewState from '../viewmodule/ViewState';
import FieldConfigs from "../datamodule/FieldConfigs";

class PageFlowEngine {
    static transformConfig(pageConfig, state) {
        if (!pageConfig) return null;
        if (pageConfig.component) return pageConfig;
        const code = pageConfig.code;
        const query = PageFlowEngine.testRoot(pageConfig.query, state);
        const title = PageFlowEngine.testRoot(pageConfig.title, state);
        const tree = PageFlowEngine.testRoot(pageConfig.tree, state);
        let body = PageFlowEngine.testRoot(pageConfig.body instanceof Array ? pageConfig.body : [pageConfig.body], state);
        if (body.type && body.type != FieldType.FORM) {
            body = {fields:[body]};
        } else if (body instanceof Array) {
            body = {fields:body};
        }
        return Object.assign({}, FieldConfigs.getConfig(FieldType.PAGE), {code, query, title, tree, body}, {name:pageConfig.name, filter:pageConfig.filter, condition:pageConfig.condition, visible:pageConfig.visible});
    }
    static transformSearchConfig(pageConfig) {
        if (!pageConfig) return null;
        const query = PageFlowEngine.testRoot(pageConfig.query, ViewState.LIST);
        const title = PageFlowEngine.testRoot(pageConfig.title, ViewState.LIST);
        const tree = PageFlowEngine.testRoot(pageConfig.tree, ViewState.LIST);
        const body = PageFlowEngine.testRoot(Object.assign({type:FieldType.TABLE}, pageConfig.body), ViewState.LIST);
        return Object.assign({}, FieldConfigs.getConfig(FieldType.PAGE), {query, title, tree, body}, {name:pageConfig.name, filter:pageConfig.filter, condition:pageConfig.condition, visible:pageConfig.visible});
    }
    static transformFormConfig(formConfig) {
        if (!formConfig) return null;
        const body = PageFlowEngine.testRoot(Object.assign({type:FieldType.FORM}, formConfig), ViewState.EDIT);
        return Object.assign({}, FieldConfigs.getConfig(FieldType.FORM), body, {name:formConfig.name, visible:formConfig.visible});
    }

    static testRoot(root, state) {
        if (root instanceof Array) {
            return {fields:PageFlowEngine.testConfig(root, state)}
        } else return PageFlowEngine.testConfig(root, state);
    }

    static testField(field, state) {
        switch (field.type) {
            case ViewType.FORM:
            case ViewType.TABLE:
            case ViewType.QUERY:
            case ViewType.TITLE:
                const config = PageFlowEngine.testConfig(field.config || field, state);
                return Object.assign({}, FieldConfigs.getConfig(field.type), {name:field.name, config:config, field:field.field});
            case ViewType.TAB:
                return PageFlowEngine.testConfig(field.config || field, state);
            case ViewType.PAGE:
                return PageFlowEngine.transformConfig(field, state); //Object.assign({}, FieldConfigs.getConfig(field.type), field); // 
            default: return Object.assign({}, field);
        }
    }

    static testConfig(config, state) {
        if (!config) return null;
        if (config instanceof Array) {
            const configs = [];
            for (const conf of config) configs.push(PageFlowEngine.testField(conf || '', state));
            return configs;
        }
        const conf = {...config};
        let fields = conf.fields || conf.view?.fields;
        if (config.view) conf.view = {...conf.view};
        if (!fields && !config.view) return conf;
        if (!fields && config.nameField) fields = [config.nameField];
        const fs = [];
        for (const field of fields) {
            if (!(field instanceof Object) || field.relPath) {
                fs.push(field instanceof Object ? {...field} : field);
            } else {
                fs.push(PageFlowEngine.testField(field));
            }
        }
        if (fs.length) {
            if (conf.view) conf.view.fields = fs;
            else conf.fields = fs;
        }
        return PageFlowEngine.getConfig(conf, state);
    }

    static getConfig(config, state) {
        let dataView = null;
        const conf = Object.assign({}, config, FieldConfigs.getConfig(config.type));
        if (config.view instanceof DataView) {
            dataView = config.view;
        } else {
            if (config.view) {
                dataView = new DataView(config.view);
            } else if (config.fields) {
                dataView = new DataView({fields:config.fields});
            }
        }
        switch (config.type) {
            case ViewType.QUERY:
                conf.view = dataView;
                conf.fields = dataView.getQueryFields();
                break;
            case ViewType.TITLE:
                break;
            case ViewType.TABLE:
                conf.view = dataView;
                conf.fields = dataView.getTableFields();
                break;
            case ViewType.FORM:
                conf.view = dataView;
                if (state == ViewState.EDIT || state == ViewState.CREATE) {
                    conf.fields = dataView.getFormFields();
                } else {
                    conf.fields = dataView.getViewFields();
                }
                break;
            default:
                conf.view = dataView;
                conf.fields = dataView.getViewFields();
                break;
        }
        return conf;
    }
}

export default PageFlowEngine;